import { func, object } from 'prop-types';
import React from 'react';

import ContentColumns from '../../components/ContentColumns';
import { timeLeftFollowup } from 'routes/Documents/routes/OnlineRehabilitation/utils';
import { path } from 'ramda';

const View4 = (_, { fm, formValues }) => {
  const finished = path(['rehab7', 'finished'], formValues);

  return (
    <React.Fragment>
      <ContentColumns
        firstColumn={
          <div>
            <h2>{fm('onlineRehabilitation.rehab7.4.header')}</h2>
            <br />
            <div>{fm('onlineRehabilitation.rehab7.4.text')}</div>
            <br />
            <div>
              {fm('onlineRehabilitation.untilFollowup')} {timeLeftFollowup(finished)}
            </div>
          </div>
        }
      />
    </React.Fragment>
  );
};

View4.contextTypes = {
  fm: func,
  formValues: object,
};

export default View4;
